module.exports = __webpack_public_path__ + "img/sic.5d547620.png";